import { z } from "zod";

export const assignTicketCrewSchema = z.object({
	assignmentId: z.string().optional(),
	ticketId: z.string(),
	assignmentRanking: z.number().optional(),
});
